import React from 'react'
import PropTypes from 'prop-types'

import UI5CalendarRange from "../../calendar-v2/calendar-range"

export default class DateRangeCalendar extends React.Component {

    static propTypes = {
        selectedRange   : PropTypes.object,

        minDate         : PropTypes.object,
        maxDate         : PropTypes.object,

        presets         : PropTypes.any,

        onSelect        : PropTypes.func,
    }

    static defaultProps = {
        presets: []
    }

    render() {
        return (
            <div className={Classes("fl-ac", this.props.className)}>
                <UI5CalendarRange selectedRange = {this.props.selectedRange}
                                  minDate       = {this.props.minDate}
                                  maxDate       = {this.props.maxDate}
                                  presets       = {this.props.presets}
                                  onSelect      = {this.props.onSelect}/>
            </div>
        );
    }
}